import { ReactNode } from 'react'

type PaddingProps = {
  /** padding общий */
  p?: number | string
  /** padding сверху */
  pt?: number
  /** padding снизу */
  pb?: number
  /** padding слева */
  pl?: number
  /** padding справа */
  pr?: number
  /** padding слева и справа */
  px?: number
  /** padding сверху и снизу */
  py?: number
  className?: string
  style?: React.CSSProperties
  children?: ReactNode
}

export const Padding = ({ p, pt, pb, pl, pr, px, py, className, style, children }: PaddingProps) => {
  const padding = p ? p : px ? `0 ${px}px` : py ? `${py}px 0` : undefined

  const getStyle = () => {
    if (padding) {
      return {
        padding,
      }
    } else if (pt) {
      return {
        paddingTop: pt,
      }
    } else if (pb) {
      return {
        paddingBottom: pb,
      }
    } else if (pl) {
      return {
        paddingLeft: pl,
      }
    } else if (pr) {
      return {
        paddingRight: pr,
      }
    }
  }

  return (
    <div style={{ ...getStyle(), ...style }} className={className}>
      {children}
    </div>
  )
}
